var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"carousel"},[(_vm.view.config.type == 'boxes')?_c('Boxes',{attrs:{"slides":_vm.items,"view":_vm.view}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }